import React from "react";
import "./styles/styles.css";
import Card from "./components/card";

const App = () => {
  return <Card />;
};

export default App;
